import React, { useEffect } from "react";
import TitlePages from "../../layout/TitlePages";
import "./FinesInstitucionales.css";

const finesList = [
  {
    id: "I",
    text: "Contribuir al desarrollo de la vida democrática de los ciudadanos residentes en el Estado.",
    icon: (
      // Ciudadanía / Comunidad
      <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
  },
  {
    id: "II",
    text: "Promover, fomentar y preservar el fortalecimiento democrático del sistema de partidos políticos y la participación electoral de los candidatos independientes.",
    icon: (
      // Sistema de partidos / Bandera cívica
      <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
        <line x1="4" y1="22" x2="4" y2="15" />
      </svg>
    ),
  },
  {
    id: "III",
    text: "Promover, fomentar y preservar el ejercicio de los derechos político-electorales y la vigilancia en el cumplimiento de sus obligaciones.",
    icon: (
      // Derechos y vigilancia / Escudo protector
      <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        <polyline points="9 12 11 14 15 10" />
      </svg>
    ),
  },
  {
    id: "IV",
    text: "Velar por la autenticidad y efectividad del sufragio.",
    icon: (
      // Urna electoral con ranura
      <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M19 8H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2z" />
        <path d="M9 3h6v5H9z" />
        <line x1="10" y1="12" x2="14" y2="12" />
      </svg>
    ),
  },
  {
    id: "V",
    text: "Garantizar la celebración libre, auténtica y periódica de las elecciones para renovar los poderes Legislativo y Ejecutivo, así como los ayuntamientos y las presidencias de comunidad.",
    icon: (
      // Elecciones periódicas / Calendario electoral
      <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
        <path d="M8 14h.01" />
        <path d="M12 14h.01" />
        <path d="M16 14h.01" />
        <path d="M8 18h.01" />
        <path d="M12 18h.01" />
      </svg>
    ),
  },
  {
    id: "VI",
    text: "Velar por la libertad, autenticidad y efectividad del sufragio y el voto popular.",
    icon: (
      // Voto popular / Boleta con verificación
      <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <polyline points="9 15 11 17 15 13" />
      </svg>
    ),
  },
  {
    id: "VII",
    text: "Llevar a cabo la promoción del sufragio y el voto.",
    icon: (
      // Promoción del voto / Megáfono
      <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 11v3a1 1 0 0 0 1 1h2.5l5 4V5l-5 4H4a1 1 0 0 0-1 1z" />
        <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
        <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
      </svg>
    ),
  },
  {
    id: "VIII",
    text: "Difundir la cultura política democrática y la educación cívica.",
    icon: (
      // Educación cívica / Libro abierto
      <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z" />
        <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z" />
      </svg>
    ),
  },
  {
    id: "IX",
    text: "Difundir, planear, desarrollar y realizar los procesos de consulta ciudadana de acuerdo con lo que prescriben la Constitución Local y las leyes aplicables.",
    icon: (
      // Consulta ciudadana / Diálogo participativo
      <svg viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        <path d="M8 9h8" />
        <path d="M8 13h5" />
      </svg>
    ),
  },
];

const FinesInstitucionales = () => {
  useEffect(() => {
    document.title = `Fines Institucionales`;
  }, []);

  return (
    <div className="fines-page-wrapper">
      {/* Banner de título minimalista reutilizable con sección */}
      <TitlePages
        section="acerca-ite"
        title="Fines Institucionales"
      />

      {/* Párrafo introductorio destacado SIN tarjeta */}
      <div className="fines-intro-block">
        <p className="fines-intro-text">
          La Ley de Instituciones y Procedimientos Electorales para el Estado de
          Tlaxcala establece como fines institucionales los siguientes:
        </p>
      </div>

      {/* Lista semántica limpia (<ol>) SIN cards */}
      <ol className="fines-list" aria-label="Fines Institucionales del ITE">
        {finesList.map((item, index) => (
          <li
            key={item.id}
            className="fines-row"
            tabIndex="0"
            style={{ animationDelay: `${index * 60}ms` }}
          >
            {/* Izquierda: Badge morado con número romano (ancho fijo 48px) */}
            <div className="fines-badge" aria-label={`Fin institucional ${item.id}`}>
              {item.id}
            </div>

            {/* Centro: Texto con flex: 1 */}
            <div className="fines-text-wrapper">
              <p className="fines-text">{item.text}</p>
            </div>

            {/* Derecha: Círculo de 44px con ícono temático SVG centrado */}
            <div className="fines-icon-circle" aria-hidden="true">
              {item.icon}
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
};

export default FinesInstitucionales;
